import { takeEvery, call, put, fork, cancel, delay } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'connected-react-router';
import { eventChannel, END } from 'redux-saga'

function* onLocationChanged({ payload }) {
  yield call(setTimeout,() => window.scrollTo(0, 0), 0);
}

export function* badRequest() {
  yield new Promise(resolve => setTimeout(resolve, 2000));
  if (Math.random() > 0.5) {
    throw Error('Error example: Something went wrong');
  }
}

export function* debounceFor(pattern, saga, ms, ...args) {
  function* delayedSaga(action) {
    yield delay(ms);
    yield call(saga, action, ...args);
  }

  let task;
  while (true) {
    const action = yield pattern;
    if (task) {
      yield cancel(task);
    }

    task = yield fork(delayedSaga, action);
  }
}

export function countdown(secs) {
  return eventChannel(emitter => {
      const iv = setInterval(() => {
        secs -= 1;
        if (secs > 0) {
          emitter(secs)
        } else {
          // this causes the channel to close
          emitter(END)
        }
      }, 1000);
      // The subscriber must return an unsubscribe function
      return () => {
        clearInterval(iv)
      }
    }
  )
}

export function* fetchDataFromServer(fetchRoutine, fetch, { mapResponse = res => res } = {}) {
  try {
    yield put(fetchRoutine.request());
    const response = yield call(fetch);
    yield put(fetchRoutine.success(mapResponse(response.items)));
  } catch (error) {
    yield put(fetchRoutine.failure(error.message || error));
  } finally {
    yield put(fetchRoutine.fulfill());
  }
}

export default [
  takeEvery(LOCATION_CHANGE, onLocationChanged),
];
